module.exports = __webpack_public_path__ + "img/client.4d5dc377.svg";